var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import styled from '@emotion/styled';
import { display, flex, themeGet } from 'styled-system';
var SearchInputBorder = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n  ", ";\n\n  position: relative;\n  border: 1px solid;\n  overflow: hidden;\n  background-color: white;\n\n  ", ";\n"], ["\n  ", ";\n  ", ";\n\n  position: relative;\n  border: 1px solid;\n  overflow: hidden;\n  background-color: white;\n\n  ",
    ";\n"])), display, flex, function (props) {
    var focused = props.focused, locked = props.locked, timeout = props.timeout, theme = props.theme;
    return __assign({ borderRadius: theme.isHome24 ? (locked ? '3px' : '3px 0 0 3px') : 0, marginLeft: locked ? 0 : '-40px', transitionProperty: 'margin-left', borderColor: focused
            ? themeGet('colors.gray.9')(props)
            : themeGet('colors.gray.5')(props) }, (locked
        ? {
            // Input border timing functions are coordinated with "Back"
            // button, when button is shown with ease-out, border is in the
            // locked state and should animate accordingly
            transitionTimingFunction: 'ease-out',
            // We apply delay on appear to animate it after the form itself
            // transitioned in the "right" place
            transitionDelay: timeout + "ms",
            transitionDuration: timeout + "ms",
        }
        : {
            transitionTimingFunction: 'ease-in',
            transitionDuration: timeout + "ms",
            borderRight: 'none',
        }));
});
SearchInputBorder.defaultProps = {
    display: 'flex',
    flex: '1 1 auto',
};
export default SearchInputBorder;
var templateObject_1;
